import React, { useState } from "react";
import toast from "react-hot-toast";
import { employeeApi } from "../../../API/Api";
import { PhoneInput } from "react-international-phone";

const Form = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    companyUrl: "",
    contactPerson: "",
    email: "",
    phone: "",
    jobTitle: "",
    jobLocation: "",
    employmentType: "",
    experience: "",
    workAuth: "",
    file: null,
  });

  const [errors, setErrors] = useState({});

  // handle input change
  // handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file" && files.length > 0) {
      const file = files[0];

      // size check → 2MB (2 * 1024 * 1024)
      if (file.type === "application/pdf" && file.size > 2 * 1024 * 1024) {
        toast.error("PDF file size must be less than 2MB");
        return;
      }

      setFormData({
        ...formData,
        file,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // validation rules
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "companyName":
        if (!value.trim()) error = "Company name is required";
        break;
      case "companyUrl":
        if (!value.trim()) {
          error = "Company URL is required";
        } else if (!/^https?:\/\/.+\..+/.test(value)) {
          error = "Enter a valid company URL";
        }
        break;
      case "contactPerson":
        if (!value.trim()) {
          error = "Contact Person Name is required";
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = "Name can only contain letters and spaces";
        }
        break;
      case "email":
        if (!value.trim()) {
          error = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Enter a valid email";
        }
        break;
      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else if (!/^\+?[0-9]{7,15}$/.test(value)) {
          error = "Phone must be 10 digits";
        }
        break;
      case "jobTitle":
      case "jobLocation":
      case "employmentType":
      case "experience":
        if (!value) error = "This field is required";
        break;
      default:
        break;
    }
    return error;
  };

  // handle blur
  const handleBlur = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: validateField(name, value),
    });
  };

  // handle submit

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstError = Object.values(newErrors)[0];
      toast.error(firstError);
      return;
    }

    try {
      const res = await employeeApi.submitEmployeeForm(formData);
      console.log("✅ API Response:", res);
      toast.success("Form Submitted Successfully!");

      // reset form
      setFormData({
        companyName: "",
        companyUrl: "",
        contactPerson: "",
        email: "",
        phone: "",
        jobTitle: "",
        jobLocation: "",
        employmentType: "",
        experience: "",
        workAuth: "",
        file: null,
      });
    } catch (err) {
      console.error("❌ API Error:", err);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center py-4">
      <div className="d-flex recruit-form flex-column flex-md-row w-100">
        {/* Left Form Panel */}
        <div className="form-panel col-md-6 text-start">
          <h2 className="fw-semibold mb-1" style={{ fontSize: "24px" }}>
            Ready for Your Next Great Hire?
          </h2>
          <p
            className="text-muted mb-3  text-start"
            style={{ fontSize: "16px" }}
          >
            We handle the search, you meet the talent.
          </p>

          <form className="text-muted small" onSubmit={handleSubmit} noValidate>
            <div className="row">
              {/* Company Name */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Company Name*</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.companyName ? "is-invalid" : ""
                  }`}
                  required
                />
                {errors.companyName && (
                  <div className="invalid-feedback text-start">
                    {errors.companyName}
                  </div>
                )}
              </div>

              {/* Company URL */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Company URL*</label>
                <input
                  type="url"
                  name="companyUrl"
                  value={formData.companyUrl}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.companyUrl ? "is-invalid" : ""
                  }`}
                  required
                />
                {errors.companyUrl && (
                  <div className="invalid-feedback text-start">
                    {errors.companyUrl}
                  </div>
                )}
              </div>

              {/* Contact Person */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Contact Person Name</label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.contactPerson ? "is-invalid" : ""
                  }`}
                />
                {errors.email && (
                  <div className="invalid-feedback text-start">
                    {errors.contactPerson}
                  </div>
                )}
              </div>

              {/* Email */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Email Address*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  required
                />
                {errors.email && (
                  <div className="invalid-feedback text-start">
                    {errors.email}
                  </div>
                )}
              </div>

              {/* Phone */}
              <div className="col-md-6 mb-2">
                <label className="form-label ">Phone Number*</label>

                <PhoneInput
                  defaultCountry="in"
                  value={formData.phone}
                  onChange={(phone) =>
                    setFormData({
                      ...formData,
                      phone,
                    })
                  }
                  className={`${errors.phone ? "is-invalid" : ""}`}
                  inputStyle={{
                    width: "100%",
                    height: "38px",
                    color: "black",
                    borderRadius: 5,
                    paddingLeft: "10px",
                    border: "2px solid #cbb4f7 ",
                  }}
                  buttonStyle={{ border: "none", backgroundColor: "#1a1a1a" }}
                  containerStyle={{ width: "100%" }}
                  enableSearch={true}
                />
                {errors.phone && (
                  <div className="invalid-feedback text-start">
                    {errors.phone}
                  </div>
                )}
              </div>

              {/* Job Title */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Job Title*</label>
                <select
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-select ${
                    errors.jobTitle ? "is-invalid" : ""
                  }`}
                  required
                >
                  <option value="">Select</option>
                  <option>Frontend Developer</option>
                  <option>Backend Developer</option>
                  <option>Full Stack Engineer</option>
                </select>
                {errors.jobTitle && (
                  <div className="invalid-feedback text-start">
                    {errors.jobTitle}
                  </div>
                )}
              </div>

              {/* Job Location */}
              <div className="col-md-6 mb-2 ">
                <label className="form-label">Job Location*</label>
                {/* <img
                  src="https://flagcdn.com/w20/in.png"
                  alt="IN"
                  className="flag-icon"
                /> */}
                <select
                  name="jobLocation"
                  value={formData.jobLocation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-select ${
                    errors.jobLocation ? "is-invalid" : ""
                  }`}
                  required
                >
                  <option value="">Select</option>
                  <option>Remote</option>
                  <option>Mumbai</option>
                  <option>Bangalore</option>
                </select>
                {errors.jobLocation && (
                  <div className="invalid-feedback text-start">
                    {errors.jobLocation}
                  </div>
                )}
              </div>

              {/* Employment Type */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Employment Type*</label>
                <select
                  name="employmentType"
                  value={formData.employmentType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-select ${
                    errors.employmentType ? "is-invalid" : ""
                  }`}
                  required
                >
                  <option value="">Select</option>
                  <option>Full-time</option>
                  <option>Part-time</option>
                  <option>Contract</option>
                </select>
                {errors.employmentType && (
                  <div className="invalid-feedback text-start">
                    {errors.employmentType}
                  </div>
                )}
              </div>

              {/* Experience Range */}
              <div className="col-md-6 mb-2">
                <label className="form-label">Experience Range*</label>
                <select
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-select ${
                    errors.experience ? "is-invalid" : ""
                  }`}
                  required
                >
                  <option value="">Select</option>
                  <option>0-1 years</option>
                  <option>1-3 years</option>
                  <option>3-5 years</option>
                  <option>5+ years</option>
                </select>
                {errors.experience && (
                  <div className="invalid-feedback text-start">
                    {errors.experience}
                  </div>
                )}
              </div>

              {/* Work Authorisation */}
              <div className="col-md-6 mb-2">
                <label className="form-label">
                  Work Authorisation Required
                </label>
                <select
                  name="workAuth"
                  value={formData.workAuth}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* File Upload */}
              <div className="col-md-12 mb-2">
                <label className="form-label" htmlFor="fileInput">
                  Upload JD / Additional Docs
                </label>
                <div className="file-upload">
                  <label htmlFor="fileInput" className="btn-upload">
                    <i className="fas fa-upload"></i>
                    <span>
                      {formData.file ? formData.file.name : "Attach a file"}
                    </span>
                  </label>
                  <input
                    id="fileInput"
                    name="file"
                    type="file"
                    accept=".doc,.docx,.pdf"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="text-center d-flex justify-content-center">
              <button
                type="submit"
                className="submit-btn btn-sm mt-3 employee-hero-btn"
              >
                Submit
              </button>
            </div>
          </form>
        </div>

        {/* Right Panel */}
        <div className="right-panel col-md-6">
          <div className="right-panel-content">
            <h3 className="fw-semibold fs-6 mb-2 text-black">
              Welcome to Anaxis Recruit
            </h3>
            <p className="small text-black">
              Share your job requirements, and we will help you find the right
              talent fast and hassle-free.
            </p>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .employee-hero-btn {
            display: block !important;
          }
          [type="button"]:not(:disabled),
          [type="reset"]:not(:disabled),
          [type="submit"]:not(:disabled),
          button:not(:disabled) {
            display: none;
          }
        `}
      </style>
    </div>
  );
};

export default Form;
